import React from "react";
import HeaderOne from "./HeaderOne";
import FooterOne from "./FooterOne";

const ShippingPolicy = () => {
  document.title = "Shipping Policy | MordenBazaar";

  return (
    <>
      <HeaderOne />

      <div className="page-content pt-0">
        <div className="container py-5">
          <div className="row justify-content-center">
            <div className="col-12 col-lg-9 col-xl-8">

              <h1 className="mt-4 mb-4">Shipping Policy</h1>

              {/* INTRO */}
              <ul className="list-disc pl-5 mb-5 space-y-2">
                <li>This policy explains how MordenBazaar processes, ships, and delivers orders across India.</li>
                <li>We aim to ensure fast, safe, and reliable delivery for every order.</li>
              </ul>

              {/* 1 */}
              <h2 className="mt-5 mb-3">1. Order Dispatch</h2>
              <ul className="list-disc pl-5 mb-4 space-y-2">
                <li>Orders are processed and dispatched within 2–3 business days after confirmation.</li>
                <li>Currently, shipping is available only within India.</li>
              </ul>

              {/* 2 */}
              <h2 className="mt-5 mb-3">2. Delivery Timeframe</h2>
              <ul className="list-disc pl-5 mb-4 space-y-2">
                <li><strong>Metro Cities:</strong> 2–4 business days after dispatch</li>
                <li><strong>Other Locations:</strong> 5–7 business days after dispatch</li>
                <li>Delivery timelines may vary due to festivals, holidays, or unforeseen delays.</li>
              </ul>

              {/* 3 */}
              <h2 className="mt-5 mb-3">3. Shipping Locations & Serviceability</h2>
              <ul className="list-disc pl-5 mb-4 space-y-2">
                <li>We deliver to all serviceable locations supported by our courier partners.</li>
                <li>Any location restrictions are displayed during checkout.</li>
              </ul>

              {/* 4 */}
              <h2 className="mt-5 mb-3">4. Shipping Partners</h2>
              <ul className="list-disc pl-5 mb-4 space-y-2">
                <li>We use trusted logistics partners such as Shiprocket.</li>
                <li>Deliveries may occur on weekends or public holidays depending on courier availability.</li>
              </ul>

              {/* 5 */}
              <h2 className="mt-5 mb-3">5. Shipping Charges</h2>
              <ul className="list-disc pl-5 mb-4 space-y-2">
                <li>Free shipping on orders above ₹1,499.</li>
                <li>Orders below ₹1,499 incur a shipping fee of ₹50.</li>
              </ul>

              {/* 6 */}
              <h2 className="mt-5 mb-3">6. Cash on Delivery (CoD)</h2>
              <ul className="list-disc pl-5 mb-4 space-y-2">
                <li>Cash on Delivery is available for eligible locations and order values.</li>
              </ul>

              {/* 7 */}
              <h2 className="mt-5 mb-3">7. Order Tracking & Notifications</h2>
              <ul className="list-disc pl-5 mb-4 space-y-2">
                <li>Customers receive SMS and email updates for order confirmation, dispatch, and delivery.</li>
                <li>Tracking details are available under “My Orders” in your account.</li>
              </ul>

              {/* 8 */}
              <h2 className="mt-5 mb-3">8. Address Changes</h2>
              <ul className="list-disc pl-5 mb-4 space-y-2">
                <li>Shipping address changes are allowed within 24 hours of order placement, before dispatch.</li>
              </ul>

              {/* 9 */}
              <h2 className="mt-5 mb-3">9. Pre-Orders & Backorders</h2>
              <ul className="list-disc pl-5 mb-4 space-y-2">
                <li>Pre-orders may be available for select upcoming products.</li>
                <li>Estimated delivery dates are shown on product pages.</li>
                <li>Standard delivery timelines apply once items are in stock.</li>
              </ul>

              {/* 10 */}
              <h2 className="mt-5 mb-3">10. Delivery Issues</h2>
              <ul className="list-disc pl-5 mb-4 space-y-2">
                <li>If an order is marked as delivered but not received, contact support within 3 days.</li>
                <li>Any unforeseen delivery delays will be communicated proactively.</li>
              </ul>

              {/* 11 */}
              <h2 className="mt-5 mb-3">11. Delivery Scheduling</h2>
              <ul className="list-disc pl-5 mb-4 space-y-2">
                <li>Scheduled or time-slot deliveries are currently not supported.</li>
              </ul>

              {/* 12 */}
              <h2 className="mt-5 mb-3">12. Return Pickup Policy</h2>
              <ul className="list-disc pl-5 mb-4 space-y-2">
                <li>Home pickup is provided for returns in eligible locations.</li>
                <li>If pickup is unavailable, alternative return methods will be shared.</li>
                <li>Shipping charges may be reimbursed where applicable.</li>
                <li>Refer to the Refund & Return Policy for full details.</li>
              </ul>

              {/* SUPPORT */}
              <h2 className="mt-5 mb-3">Customer Support</h2>
              <ul className="list-disc pl-5 mb-5 space-y-2">
                <li><strong>Email:</strong> support@mordenbazaar.com</li>
              </ul>

            </div>
          </div>
        </div>
      </div>

      <FooterOne />
    </>
  );
};

export default ShippingPolicy;